import { Box, CircularProgress, Container, LinearProgress, Stack, Tab, Tabs, Typography } from "@mui/material";
import AlertService from "../../services/AlertService";
import ProductoService from "../../services/ProductoService";
import UsuarioService from "../../services/UsuarioService";
import { useContext, useEffect, useState } from "react";
import { OptionReactSelect, Usuario, getVoidOption, setUsuarioSelect } from "../../interfaces/UsuarioSearch";
import { CasUserContext, useCasUserContext } from "../../services/casUserContext";
import { TablaProductoIngresadoDTO } from "../../interfaces/TablaProductoIngresadoDTO";
import ProductosIngresados from "../../componentes/Productos/ProductosIngresados";
import Select from 'react-select';
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import { AdaptiveSelect } from "../../componentes/Common/AdaptiveSelect";
import { Option } from '../../interfaces/ProyectosDTOS/Option';
import ProductosParticipoProyecto from "../../componentes/Productos/ProductosParticipoProyecto";
import { PersonaInvDTO } from "../../interfaces/Usuarios/PersonaInvDTO";

const alertaService = new AlertService();
const productoService = new ProductoService();
const usuarioService = new UsuarioService();

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const BusqProductosPage: React.FC<{}> = () => {
  const [listUser, setListUser] = useState<Array<OptionReactSelect>>([]);
  const [investigador, setInvestigador] = useState<OptionReactSelect>(getVoidOption());
  const [listUsuario, setListUsuario] = useState<Array<PersonaInvDTO>>([]);
  let [productosIngresados, setProductosIngresados] = useState<Array<TablaProductoIngresadoDTO>>([]);
  let [productosParticipo, setProductosParticipo] = useState<Array<TablaProductoIngresadoDTO>>([]);
  let [productosPorTitulo, setProductosPorTitulo] = useState<Array<TablaProductoIngresadoDTO>>([]);
  const [ready, setReady] = useState(false);
  const [busqEnd, setBusqEnd] = useState(true);
  const [auth, setAuth] = useState(false);
  const [tab, setTab] = useState(0);

  //const casUserContext = useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  const token = casUserContext.token;
  const user = casUserContext.userData;

  //#region Interactive
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  }
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  const fillOptionsTitulo = async (searchTerm: string) => {
    try {
      const data = await productoService.GetOptionsProdTerminByTitulo(searchTerm, token);
      if (data.status.isSuccessfully) {
        return data.listData;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  };
  const handleResponseTitulo = (selectedValue: Option) => {
    // Aquí puedes decidir qué hacer con el valor seleccionado
    // Por ejemplo, podrías establecerlo en la variable 'codigo'
    //console.log(selectedValue);
    //searchListProductosTitulo(selectedValue.label);
    searchListProductosid(selectedValue.value);
  };
  //#endregion

  const fetchData = async () => {
    try {
      await usuarioService.GetListUsuarios(token)
        .then((data) => {
          //console.log(data);
          if (data.status.isSuccessfully) {
            setListUsuario(data.listData);
            setListUser(setUsuarioSelect(data.listData));
            setReady(true);
          } else {
            alertaService.alertaAdvertencia("Error", "No se cargaron los usuarios");
            setReady(true);
          }
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const searchListProductos = async (idinv: string) => {
    alertaService.showLoading("Espere...");
    setBusqEnd(false);
    //console.log(idinv);
    let invNum = parseInt(idinv, 10);
    await productoService.GetProductosIngresadosUsuario(invNum, token)
      .then((data) => {
        //console.log(data)
        //setProductosIngresados(data.listData);
        if (data.status.isSuccessfully) {
          //console.log(data.listData)
          alertaService.hideLoading();
          setProductosIngresados(data.listData);
          alertaService.alertaExito("Exito", "Se obtuvo respuesta.");
        } else {
          alertaService.hideLoading();
          alertaService.alertaAdvertencia("Alerta", "No se encontraron resultados.");
        }
      })
      .catch((error) => {
        alertaService.hideLoading();
        alertaService.alertaAdvertencia("Error", error);
        console.error(error)
      });
    setBusqEnd(true);
  };

  const searchListProductosColaborador = async (idinv: string) => {
    alertaService.showLoading("Espere...");
    setBusqEnd(false);
    //console.log(idinv);
    let invNum = parseInt(idinv, 10);
    await productoService.GetProductosProyectosParticipo(invNum, token)
      .then((data) => {
        //console.log(data)
        //setProductosIngresados(data.listData);
        if (data.status.isSuccessfully) {
          //console.log(data.listData)
          alertaService.hideLoading();
          setProductosParticipo(data.listData);
          alertaService.alertaExito("Exito", "Se obtuvo respuesta.");
        } else {
          alertaService.hideLoading();
          alertaService.alertaAdvertencia("Alerta", "No se encontraron resultados.");
        }
      })
      .catch((error) => {
        alertaService.hideLoading();
        alertaService.alertaAdvertencia("Error", error);
        console.error(error)
      });
    setBusqEnd(true);
  };

  const searchListProductosTitulo = async (titulo: string) => {
    alertaService.showLoading("Espere...");
    setBusqEnd(false);
    //console.log(idinv);
    await productoService.GetProductosTerminadosPorTitulo(titulo, token)
      .then((data) => {
        console.log(data)
        //setProductosIngresados(data.listData);
        if (data.status.isSuccessfully) {
          //console.log(data.listData)
          alertaService.hideLoading();
          setProductosPorTitulo(data.listData);
          alertaService.alertaExito("Exito", "Se obtuvo respuesta.");
        } else {
          alertaService.hideLoading();
          alertaService.alertaAdvertencia("Alerta", "No se encontraron resultados.");
        }
      })
      .catch((error) => {
        alertaService.hideLoading();
        alertaService.alertaAdvertencia("Error", error);
        console.error(error)
      });
    setBusqEnd(true);
  };

  const searchListProductosid = async (id: string | number) => {
    alertaService.showLoading("Espere...");
    setBusqEnd(false);
    //console.log(idinv);
    await productoService.GetProductosTerminadosPorTituloWithIdProducto(id, token)
      .then((data) => {
        //console.log(data)
        //setProductosIngresados(data.listData);
        if (data.status.isSuccessfully) {
          //console.log(data.listData)
          alertaService.hideLoading();
          setProductosPorTitulo(data.listData);
          alertaService.alertaExito("Exito", "Se obtuvo respuesta.");
        } else {
          alertaService.hideLoading();
          alertaService.alertaAdvertencia("Alerta", "No se encontraron resultados.");
        }
      })
      .catch((error) => {
        alertaService.hideLoading();
        alertaService.alertaAdvertencia("Error", error);
        console.error(error)
      });
    setBusqEnd(true);
  };

  useEffect(() => {
    const flag = usuarioService.authorizedByRol(142, user.roles) || usuarioService.authorizedByRol(144, user.roles) || usuarioService.authorizedByRol(145,user.roles);
    setAuth(flag);
    if (flag) {
      fetchData();
    }
  }, [user]);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      {auth ?
        <>
          <Typography variant="h4" gutterBottom>
            <strong>Busqueda Productos</strong>
          </Typography>
          {ready ?
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="Investigador" {...a11yProps(0)} />
                  <Tab label="Título" {...a11yProps(1)} />
                  <Tab label="Colaborador" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <TabPanel value={tab} index={0}>
                <Box style={{ zIndex: 1000 }}
                  component="form"
                  sx={{
                    '& > :not(style)': { m: 1 },
                  }}
                  noValidate
                  autoComplete="off">
                  <Select
                    className="app-select-react"
                    classNamePrefix="select"
                    isDisabled={!ready}
                    isLoading={!ready}
                    isSearchable={ready}
                    name="usuario"
                    options={listUser}
                    onChange={(e) => searchListProductos(e?.value || '')}
                  />
                </Box>
                <br />
                {busqEnd ?
                  <ProductosIngresados rowsPerPage={[5, 10, 25, 100]} data={productosIngresados} ready={ready} mostrarAlert={false} />
                  :
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <CircularProgress color="secondary" />
                  </Stack>
                }
              </TabPanel>
              <TabPanel value={tab} index={1}>
                <Box style={{ zIndex: 1000 }}
                  component="form"
                  sx={{
                    '& > :not(style)': { m: 1 },
                  }}
                  noValidate
                  autoComplete="off">
                  <AdaptiveSelect
                    fillOptions={fillOptionsTitulo}
                    onResponse={handleResponseTitulo}
                  />
                </Box>
                <br />
                {busqEnd ?
                  <ProductosIngresados rowsPerPage={[5, 10, 25, 100]} data={productosPorTitulo} ready={ready} mostrarAlert={true} titulo="Productos Por Título" mensajeAlert="Estimado Investigador, los productos que aparecen en esta tabla son aquellos que comparten el mismo título." />
                  :
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <CircularProgress color="secondary" />
                  </Stack>
                }
              </TabPanel>
              <TabPanel value={tab} index={2}>
                <Box style={{ zIndex: 1000 }}
                  component="form"
                  sx={{
                    '& > :not(style)': { m: 1 },
                  }}
                  noValidate
                  autoComplete="off">
                  <Select
                    className="app-select-react"
                    classNamePrefix="select"
                    isDisabled={!ready}
                    isLoading={!ready}
                    isSearchable={ready}
                    name="usuario"
                    options={listUser}
                    onChange={(e) => searchListProductosColaborador(e?.value || '')}
                  />
                </Box>
                <br />
                {busqEnd ?
                  // <ProductosIngresados rowsPerPage={[5 ,10, 25, 100]} data={productosIngresados} ready={ready} mostrarAlert={false} />
                  <ProductosParticipoProyecto rowsPerPage={[5, 10, 25, 100]} data={productosParticipo} ready={ready} mostrarAlert={true} />
                  :
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <CircularProgress color="secondary" />
                  </Stack>
                }
              </TabPanel>
            </Box>
            :
            <Stack sx={{ width: '100%' }} spacing={2}>
              <LinearProgress color="primary" />
            </Stack>}
        </>
        :
        <UnauthorizedPage />
      }
    </Container>
  );
}